//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "forum_block",
  props: {
      forum_conf:undefined
  },
}
